"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Routing = require("Functions/Routing");
var _reactRouterDom = require("react-router-dom");
var _ajaxRequest = _interopRequireDefault(require("Functions/ajax/ajaxRequest"));
var _ModelPicker = _interopRequireDefault(require("Components/Forms/Elements/ModelPicker"));
var _Select = _interopRequireDefault(require("Components/Forms/Elements/Select"));
var _Editor = _interopRequireDefault(require("Components/TextEditor/Editor"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Message = _interopRequireDefault(require("../../../Chat/Message"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Chat = props => {
  let navigate = (0, _reactRouterDom.useNavigate)();
  const [message, setMessage] = (0, _react.useState)("");
  const [statusMessages, setStatusMessages] = (0, _react.useState)({});
  const [status, setStatus] = (0, _react.useState)({});
  const [relatedProject, setRelatedProject] = (0, _react.useState)("");
  const [loading, setLoading] = (0, _react.useState)(false);
  const [previousMessages, setPreviousMessages] = (0, _react.useState)();
  const [praticiansList, setPraticiansList] = (0, _react.useState)();
  let userLogin = window.app.state.session.user.login;
  const userRole = window.app.state.session.user.roles[0];
  const [sendMessageTo, setSendMessageTo] = (0, _react.useState)(undefined);
  const [relatedPratician, setRelatedPratician] = (0, _react.useState)(userLogin);
  const [projectNumber, setProjectNumber] = (0, _react.useState)("");
  if (props.type === "update") {
    (0, _react.useEffect)(() => {
      fetchMessages();
    }, []);
  } else if (props.type !== "update") {
    (0, _react.useEffect)(() => {
      fetchPraticians();
    }, []);
  }
  if (userRole === "pratician") {
    (0, _react.useEffect)(() => {
      setSendMessageTo("deltex");
    }, []);
  }
  if (userRole === "deltex") {
    userLogin = "deltex";
  }
  const loader = loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
    className: "c-loader",
    bemit: ['white', 'bg-primary']
  }) : undefined;
  const fetchMessages = () => {
    const chatId = document.location.pathname.split((0, _Routing.URL)('conversation') + "/")[1];
    setLoading(true);
    (0, _ajaxRequest.default)((0, _Routing.action)('getAllMessages'), {
      data: {
        id: chatId,
        with_count: false
      }
    }).then(response => {
      setPreviousMessages(response.data[0].content);
      setLoading(false);
      setProjectNumber(response.data[0].related_project);
    });
  };
  const fetchPraticians = () => {
    (0, _ajaxRequest.default)((0, _Routing.action)('getAllUsers'), {
      data: {
        with_count: false,
        with_deltex: false
      }
    }).then(response => {
      setPraticiansList(response.data);
    });
  };
  const sendMessage = () => {
    if (props.type === "update") {
      setLoading(true);
      const chatId = document.location.pathname.split((0, _Routing.URL)('conversation') + "/")[1];
      (0, _ajaxRequest.default)((0, _Routing.action)('updateChat'), {
        data: {
          message: message,
          send_to: sendMessageTo,
          sent_by: userLogin,
          id: chatId,
          related_project: relatedProject
        }
      }).then(() => {
        fetchMessages();
        setMessage('__editor-txt:');
        setStatus(response);
        window.setTimeout(function () {
          navigate((0, _Routing.URL)('ChatsDashboardPage'));
        }, 2000);
      }).catch(response => {
        setStatusMessages(response.status_messages);
      });
    } else relatedPratician && (0, _ajaxRequest.default)((0, _Routing.action)('createChat'), {
      data: {
        message: message,
        sent_by: userLogin,
        send_to: sendMessageTo,
        related_project: relatedProject,
        related_pratician: relatedPratician
      }
    }).then(response => {
      setPreviousMessages(response.data.content);
      setMessage('__editor-txt:');
      setStatus(response);
      window.setTimeout(function () {
        navigate((0, _Routing.URL)('ChatsDashboardPage'));
      }, 2000);
    }).catch(response => {
      setStatus(response);
      setStatusMessages(response.status_messages);
    });
  };
  let praticianSelectOptions = undefined;
  if (userRole === "pratician") {
    praticianSelectOptions = [{
      value: "deltex",
      label: "Deltex"
    }];
  } else {
    var _praticiansList$map;
    praticianSelectOptions = praticiansList === null || praticiansList === void 0 ? void 0 : (_praticiansList$map = praticiansList.map) === null || _praticiansList$map === void 0 ? void 0 : _praticiansList$map.call(praticiansList, pratician => ({
      value: pratician.login,
      label: pratician.login + "-" + pratician.firstname + " " + pratician.name
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chat"
  }, props.type === "update" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "previous_messages"
  }, /*#__PURE__*/_react.default.createElement("h3", null, projectNumber), /*#__PURE__*/_react.default.createElement("h4", null, "Historique des messages :"), previousMessages && previousMessages.map(message => /*#__PURE__*/_react.default.createElement(_Message.default, {
    key: message.message_date,
    message: message
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "width-50"
  }, praticianSelectOptions && praticianSelectOptions ? /*#__PURE__*/_react.default.createElement(_Select.default, {
    onChange: e => {
      setSendMessageTo(e.value);
      userRole === "deltex" ? setRelatedPratician(e.value) : undefined;
    },
    label: "Destinataire",
    value: sendMessageTo || "",
    name: "chat[send_to]",
    status: statusMessages,
    options: praticianSelectOptions,
    required: true
  }) : undefined, /*#__PURE__*/_react.default.createElement(_ModelPicker.default, {
    onPick: e => setRelatedProject(e.value),
    model: "Project",
    picked: relatedProject || "",
    name: "chat[related_project]",
    status_messages: statusMessages,
    className: "project_picker"
  }))), /*#__PURE__*/_react.default.createElement(_Editor.default, {
    className: "u-padding-top-20",
    "text-only": true,
    label: "Message",
    value: message,
    onChange: e => setMessage(e.value),
    name: "chat[message]",
    status: statusMessages
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _bemit.default)('c-flat-btn', ['primary']) + ' u-margin-top-15',
    onClick: sendMessage
  }, "Envoyer", loader), (0, _getFormStatus.default)(status));
};
var _default = exports.default = Chat;
